const paymentTermsSelectorElementCreate = document.getElementById('test-payment-terms-selector');
const formDataCreate = document.getElementById('form-data');

paymentTermsSelectorElementCreate.addEventListener('outputPaymentTermForm', function(event) {
  if ((event as any).detail) {
    formDataCreate.innerText = JSON.stringify((event as any).detail);
  }
});
